import { RateGroupKindEnum } from '@graphql/platform';

import { useSharedCheckoutContext } from '@root/components/checkout/context';
import { COMMITMENT_TO_LENGTH } from '@root/constants/pricing';

export const useCommitmentTermLength = () => {
  const {
    flowState: { values },
  } = useSharedCheckoutContext();
  const { commitment } = values;

  return COMMITMENT_TO_LENGTH[commitment ?? RateGroupKindEnum.Mover];
};
